<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Login</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text>
            <v-form
              ref="loginForm"
            >
              <v-text-field
                label="Email"
                name="email"
                :rules="emailRules"
                v-model="loginForm.email"
                prepend-icon="mdi-email"
                type="email"
                required
              ></v-text-field>

              <v-text-field
                id="password"
                label="Password"
                name="password"
                v-model="loginForm.password"
                prepend-icon="mdi-lock"
                type="password"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="login">Login</v-btn>
            <v-btn text color="primary" @click="signUp">Signup</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :timeout=2000
    >
      {{ errorMsg }}
      <v-btn
        color="pink"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    snackbar: false,
    errorMsg: null,
    loginForm: {
      email: '',
      password: '',
    },
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
  }),
  methods: {
    login() {
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch('login', { email: this.loginForm.email, password: this.loginForm.password })
          .then(() => this.$router.push('/'))
          .catch(() => { this.errorMsg = 'Login error'; this.snackbar = true; });
      }
    },
    signUp() {
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch('signUp', {
          email: this.loginForm.email,
          password: this.loginForm.password,
        }).then(() => this.$router.push('/dashboard'))
          .catch(() => { this.errorMsg = 'Unable to register account'; this.snackbar = true; });
      }
    },
  },
};
</script>

<style scoped>

</style>
